import { render, staticRenderFns } from "./OrdersOptions.vue?vue&type=template&id=83370fac&scoped=true&"
import script from "./OrdersOptions.vue?vue&type=script&lang=js&"
export * from "./OrdersOptions.vue?vue&type=script&lang=js&"
import style0 from "./OrdersOptions.vue?vue&type=style&index=0&id=83370fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83370fac",
  null
  
)

component.options.__file = "OrdersOptions.vue"
export default component.exports